export const DateTimeDataType = 'DateTime';
export const NumericDataType = 'Numeric';
export const TextDataType = 'Text';